// extracted by mini-css-extract-plugin
export default {"menuContainer":"U9DWJ9uOTrTGsXS3bt2E","menu":"Vey0TvE9pZsJfOtsZPZ1","menuItem":"mq_RoAHOiqE0ezzuIjy9","active":"DmRM2_WEZGBE5Cg4YSgH","subMenuItem":"Y8nSPuyAIONaaI6YuSGN"};